<template>
  <div class="record_container">
    <div class="info_tab" v-if="showPrint" data-html2canvas-ignore>
      <img @click="handleBack" style="width: 24px; height: 24px" src="../assets/back.png" />
      <div>{{ modelName }}</div>
      <p style="float: right; margin-right: 10px" @click="wantWx">
        <img style="width: 18px; height: 18px" src="../assets/share.png" alt="" />
        <span class="zf">{{ !pdfLoading ? '转发' : '处理中...' }}</span>
      </p>
    </div>
    <div class="info_container">
      <div class="info_submit1">
        <span>{{ initiator.staffName }}提出的{{ modelName }}</span>
        <span v-if="makeCardTimes">本月第{{ makeCardTimes }}次补卡</span>
      </div>
      <div class="info_submit2" :style="{ color: color }">{{ statusMsg }}</div>
    </div>
    <div class="approve_company">
      <span class="info_field">所属公司:</span>
      <span class="info_text">{{ initiator.companyName }}</span>
    </div>
    <div class="approve_info" style="margin-top: 0.3rem">
      <div>
        <span class="info_field">审批编号:</span>
        <span class="info_text">{{ approvalNo }}</span>
      </div>
      <div v-for="(item, index) in formList" :key="index">
        <span class="info_field" v-if="item.fieldType !== 'upload' && item.fieldType !== 'interviewInfo'">{{ handleFieldName(item, formList) }}:</span>
        <span
          v-if="
            item.fieldType !== 'interviewInfo' &&
            item.fieldType !== 'textarea' &&
            item.fieldType !== 'payees' &&
            item.fieldType !== 'paymentApplicationDetails' &&
            item.fieldType !== 'expenseReimbursementDetails' &&
            item.fieldType !== 'loanDetails' &&
            item.fieldType !== 'travelExpensesReimbursementDetails' &&
            item.fieldType !== 'oaDetails' &&
            item.fieldType !== 'witrooms' &&
            item.fieldType !== 'instrument' &&
            item.fieldType !== 'expenseDetails' &&
            item.fieldType !== 'fmsIncomeBudgetDetails' &&
            item.fieldType !== 'fmsExpendBudgetDetails' &&
            item.fieldType !== 'fmsCorrelationDeptDetails' &&
            item.fieldType !== 'fmsIncomeBudgetAdjustDetails' &&
            item.fieldType !== 'fmsExpendBudgetAdjustDetails' &&
            item.fieldType !== 'iscDeliveryAdviceDetails' &&
            item.fieldType !== 'crmOrderDetails' &&
            item.fieldType !== 'crmQuoteDetails' &&
            item.fieldType !== 'crmHKPlanDetails' &&
            item.fieldType !== 'iscInvoiceAdviceDetails' &&
            item.fieldType !== 'crmContractProductDetails' &&
            item.fieldType !== 'iscProductOrderDetail' &&
            item.fieldType !== 'iscReturnOrderDetail'
          "
          class="info_text"
        >
          {{ renderItem(item) }}
        </span>
        <div v-if="item.fieldType === 'textarea'" v-text="renderTextArea(item)" class="info_text"></div>
        <div v-if="item.fieldType === 'witrooms'">
          <div v-for="(i, index) in item.value" :key="index" class="info_witpark">
            <!-- <div class="line">{{ index + 1 }}</div> -->
            <div>{{ index + 1 }}- 楼栋:{{ i.buildingName }}</div>
            <div>楼层:{{ i.floors }}</div>
            <div style="word-break: break-all">房间号:{{ i.roomNames }}</div>
          </div>
        </div>
        <span v-if="item.fieldType === 'instrument'">
          <span>{{ item.value ? item.value.map(i => `${i.deviceTypeName}-${i.deviceNo}`).join(',') : '-' }}</span>
        </span>
        <span v-if="item.fieldType === 'expenseDetails'">
          <span>-</span>
        </span>
        <div v-if="item.fieldType === 'payees' && kitValue != 27">
          <div v-for="(i, index) in item.value" :key="index" class="approve_list">
           <div >收款人:{{ i.accountName }}</div>
            <div>银行账号:{{ i.bankAccount }}</div>
            <div>银行网点:{{ i.bankOutlets }}</div>
            <div>开户银行:{{ i.depositBank }}</div>
            <div v-if="kitValue != 26">备注描述:{{ i.remark }}</div>
            <!-- <div v-if="kitValue == 26">swiftCode:{{ i.swiftCode }}</div> -->
          </div>
        </div>
        <div v-if="item.fieldType === 'payees' && kitValue == 27">
          <div v-for="(i, index) in item.value" :key="index" class="approve_list">
            <div>银行账号:{{ i.account }}</div>
            <div>银行网点:{{ i.outlets }}</div>
            <div>开户银行:{{ i.bank }}</div>
            <div>账号名称:{{ i.accountName }}</div>
            <!-- <div>收款单位:{{ i.company }}</div> -->
            <div>备注描述:{{ i.remark }}</div>
            <div>收款金额（元）:{{ i.amount }}</div>
          </div>
        </div>
        <div v-if="item.fieldType === 'paymentApplicationDetails'">
          <div v-for="(i, index) in item.value" :key="index" class="approve_list">
            <div>费用项目:{{ i.expenseItemName }}</div>
            <div>费用金额（元）:{{ i.expenseAmount }}</div>
            <div>用途描述:{{ i.purpose }}</div>
          </div>
        </div>
        <div v-if="item.fieldType === 'expenseReimbursementDetails'">
          <div v-for="(i, index) in item.value" :key="index" class="approve_list">
            <div>费用金额（元）:{{ i.expenseAmount }}</div>
            <!-- <div>费用承担部门:{{ i.expenseBearDepName }}</div> -->
            <div>费用项目:{{ i.expenseItemName }}</div>
            <!-- <div>发票类型名称:{{ i.invoiceTypeName }}</div> -->
            <div>备注:{{ i.remark }}</div>
          </div>
        </div>
        <div v-if="item.fieldType === 'loanDetails'">
          <div v-for="(i, index) in item.value" :key="index" class="approve_list">
            <div>费用项目:{{ i.expenseItemName }}</div>
            <div>申请金额(元):{{ i.applyAmount }}</div>
            <!-- <div>费用承担部门:{{ i.expenseBearDepName }}</div> -->
            <div>备注描述:{{ i.remark }}</div>
          </div>
        </div>
        <div v-if="item.fieldType === 'travelExpensesReimbursementDetails'">
          <div v-for="(i, index) in item.value" :key="index" class="approve_list">
            <div>出差日期:{{ i.stratDate }}</div>
            <div>目的地:{{ i.destination }}</div>
            <div>机票费:{{ i.airFare }}</div>
            <div>车船费:{{ i.fare }}</div>
            <div>住宿费:{{ i.hotelExpense }}</div>
            <div>市内交通费:{{ i.localFare }}</div>
            <div>出差补助:{{ i.subsidy }}</div>
            <div>住宿节约补助:{{ i.thrift }}</div>
            <div>其他费用:{{ i.other }}</div>
            <div>金额(小计):{{ i.amount }}</div>
          </div>
        </div>
        <div v-if="item.fieldType === 'oaDetails'">
          <div class="approve_list">
            <div v-for="(i, index) in item.list" :key="index">
              <span class="approve_click" @click="getOaDetail(i)">{{ i }}</span>
            </div>
          </div>
        </div>
        <!-- ISC 退货 产品信息 -->
        <div v-if="item.fieldType === 'iscReturnOrderDetail'">
          <div v-for="(i, index) in renderTableTwo(item)" :key="index" class="approve_list">
            <!-- <div>产品编码:{{ i.materialCode }}</div> -->
            <div>产品名称:{{ i.materialName }}</div>
            <div>规格:{{ i.specParameters }}</div>
            <div>型号:{{ i.model }}</div>
            <div>源单数量:{{ i.resourceQuantity }}</div>
            <div>退货数:{{ i.quantity }}</div>
            <div>单价:{{ i.price }}</div>
            <div>退货金额:{{ i.amount }}</div>
            <div>备注描述:{{ i.remark }}</div>
          </div>
        </div>
        <!-- ISC 生产工单 产品信息 -->
        <div v-if="item.fieldType === 'iscProductOrderDetail'">
          <div v-for="(i, index) in renderTableTwo(item)" :key="index" class="approve_list">
            <div>产品编码:{{ i.materialCode }}</div>
            <div>产品名称:{{ i.materialName }}</div>
            <div>规格:{{ i.materialSpecParameters }}</div>
            <div>型号:{{ i.materialModel }}</div>
            <div>计量单位:{{ i.unitName }}</div>
            <div>应投数:{{ i.voteQuantity }}</div>
            <div>损耗率(%):{{ i.loss }}</div>
            <div>损耗数:{{ i.lossNum }}</div>
            <div>单位用量:{{ i.unitDosage }}</div>
            <div>位置:{{ i.address }}</div>
            <div>替代标识:{{ i.replaceFlag }}</div>
            <div>替代物料:{{ i.replaceMaterial }}</div>
            <div>备注描述:{{ i.remark }}</div>
          </div>
        </div>
        <!-- ISC 发货通知单 产品信息 -->
        <div v-if="item.fieldType === 'iscDeliveryAdviceDetails'">
          <div v-for="(i, index) in renderTable(item)" :key="index" class="approve_list">
            <div>产品编码:{{ i.materialCode }}</div>
            <div>产品名称:{{ i.materialName }}</div>
            <div>规格型号:{{ i.specParameters }}</div>
            <div>定长:{{ i.fixedLength }}</div>
            <div>根数:{{ i.pipeQuantity }}</div>
            <div>发货数量:{{ i.salaryQuantity }}</div>
            <div>单价:{{ i.price }}</div>
            <div>金额:{{ i.amount }}</div>
          </div>
        </div>
        <!-- ISC 销售开票 产品信息 -->
        <div v-if="item.fieldType === 'iscInvoiceAdviceDetails'">
          <div v-for="(i, index) in renderTable(item)" :key="index" class="approve_list">
            <div>产品编码:{{ i.materialCode }}</div>
            <div>产品名称:{{ i.materialName }}</div>
            <div>规格:{{ i.specParameters }}</div>
            <div>型号:{{ i.model }}</div>
            <div>单位:{{ i.unitName }}</div>
            <div>数量:{{ i.quantity }}</div>
            <div>单价:{{ i.price }}</div>
            <div>金额:{{ i.amount }}</div>
            <div>税点(%):{{ i.taxRatio * 100 }}</div>
            <div>税额:{{ i.taxAmount }}</div>
            <div>含税金额:{{ i.hasTaxAmount }}</div>
          </div>
        </div>
        <!-- 资金预算单收入预算 -->
        <div v-if="item.fieldType === 'fmsIncomeBudgetDetails'">
          <el-table show-summary :summary-method="getSummaries" :data="renderTable(item)">
            <!-- <el-table-column fixed prop="index" label="序号" width="80" /> -->
            <el-table-column label="预算收入科目" width="120" show-overflow-tooltip align="center" key="subjectName" prop="subjectName" />
            <el-table-column label="预算收入金额" width="120" show-overflow-tooltip align="center" key="amount" prop="amount">
              <template #default="scope">
                <span style="color: #409eff">{{ scope.row.amount }}</span>
              </template>
            </el-table-column>
            <el-table-column label="预算收入说明" width="120" show-overflow-tooltip align="center" key="remark" prop="remark">
              <template #default="scope">
                <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap" @click="showRemarkContent(scope.row)">{{ scope.row.remark }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 资金预算单支出预算 -->
        <div v-if="item.fieldType === 'fmsExpendBudgetDetails'">
          <el-table show-summary :summary-method="getSummaries" :data="renderTable(item)">
            <!-- <el-table-column fixed prop="index" label="序号" width="80" /> -->
            <el-table-column label="预算支出科目" width="120" show-overflow-tooltip align="center" key="subjectName" prop="subjectName" />
            <el-table-column label="预算支出金额" width="120" show-overflow-tooltip align="center" key="amount" prop="amount">
              <template #default="scope">
                <span style="color: #409eff">{{ scope.row.amount }}</span>
              </template>
            </el-table-column>
            <el-table-column label="预算支出说明" width="120" show-overflow-tooltip align="center" key="remark" prop="remark">
              <template #default="scope">
                <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap" @click="showRemarkContent(scope.row)">{{ scope.row.remark }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 资金预算单关联部门 -->
        <div v-if="item.fieldType === 'fmsCorrelationDeptDetails'">
          <el-table show-summary :summary-method="getSummaries" :data="renderTable(item)">
            <el-table-column label="资金预算单" width="120" show-overflow-tooltip align="center" key="billCode" prop="billCode">
              <template #default="scope">
                <span style="color: #409eff">{{ scope.row.billCode }}</span>
              </template>
            </el-table-column>
            <el-table-column label="资金收入总额" width="120" show-overflow-tooltip align="center" key="incomeDecideAmount" prop="incomeDecideAmount" />
            <el-table-column label="资金支出总额" width="120" show-overflow-tooltip align="center" key="expenditureDecideAmount" prop="expenditureDecideAmount" />
            <el-table-column label="预算组织" width="120" show-overflow-tooltip align="center" key="deptName" prop="deptName" />
          </el-table>
        </div>
        <!-- 资金预算调整单收入预算 -->
        <div v-if="item.fieldType === 'fmsIncomeBudgetAdjustDetails'">
          <el-table show-summary :summary-method="getSummaries" :data="renderTable(item)">
            <el-table-column width="120" label="预算收入科目" show-overflow-tooltip align="center" key="subjectName" prop="subjectName" />
            <el-table-column width="120" label="调整方式" show-overflow-tooltip align="center" key="adjustType" prop="adjustType">
              <template #default="scope">
                <span style="color: #409eff" v-if="scope.row.adjustType === 'add'">增加</span>
                <span style="color: #f56c6c" v-else>减少</span>
              </template>
            </el-table-column>
            <el-table-column width="120" label="调整金额" show-overflow-tooltip align="center" key="adjustAmount" prop="adjustAmount">
              <template #default="scope">
                <span style="color: #409eff">{{ scope.row.adjustAmount }}</span>
              </template>
            </el-table-column>
            <el-table-column width="120" label="调整说明" show-overflow-tooltip align="center" key="remark" prop="remark">
              <template #default="scope">
                <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap" @click="showRemarkContent(scope.row)">{{ scope.row.remark }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 资金预算单调整支出预算 -->
        <div v-if="item.fieldType === 'fmsExpendBudgetAdjustDetails'">
          <el-table show-summary :summary-method="getSummaries" :data="renderTable(item)">
            <!-- <el-table-column fixed prop="index" label="序号" width="80" /> -->
            <el-table-column width="120" label="预算支出科目" show-overflow-tooltip align="center" key="subjectName" prop="subjectName" />
            <el-table-column width="120" label="调整方式" show-overflow-tooltip align="center" key="adjustType" prop="adjustType">
              <template #default="scope">
                <span style="color: #409eff" v-if="scope.row.adjustType === 'add'">增加</span>
                <span style="color: #f56c6c" v-else>减少</span>
              </template>
            </el-table-column>
            <el-table-column width="120" label="调整金额" show-overflow-tooltip align="center" key="adjustAmount" prop="adjustAmount">
              <template #default="scope">
                <span style="color: #409eff">{{ scope.row.adjustAmount }}</span>
              </template>
            </el-table-column>
            <el-table-column width="120" label="调整说明" align="center" key="remark" prop="remark">
              <template #default="scope">
                <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap" @click="showRemarkContent(scope.row)">{{ scope.row.remark }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- CRM订单信息 -->
        <div v-if="item.fieldType === 'crmOrderDetails'">
          <div v-for="(i, index) in item.value" :key="index" class="approve_list">
            <div>产品编码: {{ i.productCode }}</div>
            <div>产品名称: {{ i.productName }}</div>
            <div>型号: {{ i.specs }}</div>
            <div>计量单位: {{ i.unit }}</div>
            <div>数量: {{ i.num }}</div>
            <div>含税单价(元): {{ i.unitPrice }}</div>
            <div>金额(元): {{ i.amount }}</div>
            <div>交货日期: {{ getDate('yyyy-MM-dd', item.deliveryDate) }}</div>
            <div v-if="i.remark">用途描述: {{ i.remark }}</div>
            <div v-if="i.customerItemNo">客户料号: {{ i.customerItemNo }}</div>
            <div v-if="i.orderNo">客户订单: {{ i.orderNo }}</div>
            <div v-if="i.specialRequirement">特殊要求: {{ i.specialRequirement }}</div>
          </div>
        </div>

        <!-- CRM报价信息 -->
        <div v-if="item.fieldType === 'crmQuoteDetails'">
          <div v-for="(i, index) in item.value" :key="index" class="approve_list">
            <div>产品编码: {{ i.productCode }}</div>
            <div>产品名称: {{ i.productName }}</div>
            <div>型号: {{ i.specs }}</div>
            <div>计量单位: {{ i.unit }}</div>
            <div>数量: {{ i.num }}</div>
            <div>单价(元): {{ i.unitPrice }}</div>
            <div>税率(%): {{ i.taxRate }}</div>
            <div>折扣(%): {{ i.discount }}</div>
            <div>折扣单价(元): {{ i.discountedUnitPrice }}</div>
            <div>实报价(元): {{ i.amount }}</div>
            <div>备注描述: {{ i.remark }}</div>
          </div>
        </div>

        <!-- CRM回款计划信息 -->
        <div v-if="item.fieldType === 'crmHKPlanDetails'">
          <div v-for="(i, index) in item.value" :key="index" class="approve_list">
            <div>执行状态: {{ paymentStatusGet(i) }}</div>
            <div>计划回款日期: {{ getDate('yyyy-MM-dd', item.paymentPlaneDate) }}</div>
            <div>计划回款金额(元): {{ i.paymentPlaneAmount }}</div>
            <div>剩余金额(元): {{ i.surplusAmount }}</div>
            <div>回款要求: {{ i.paymentRequirement }}</div>
            <div>备注描述: {{ i.remark }}</div>
          </div>
        </div>

        <!-- CRM合同信息 -->
        <div v-if="item.fieldType === 'crmContractProductDetails'">
          <div v-for="(i, index) in item.value" :key="index" class="approve_list">
            <div>产品编码: {{ i.productCode }}</div>
            <div>产品名称: {{ i.productName }}</div>
            <div>型号: {{ i.specs }}</div>
            <div>计量单位: {{ i.unit }}</div>
            <div>数量: {{ i.num }}</div>
            <div>单价(元): {{ i.unitPrice }}</div>
            <div>金额(元): {{ i.amount }}</div>
            <div>备注描述: {{ i.remark }}</div>
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="isShowRemarkContent" position="bottom" :style="{ width: '100%', height: '50%', padding: '10px' }">
      <div>
        {{ remarkContent }}
      </div>
    </van-popup>

    <van-popup v-model="oaVisi" position="right" :style="{ width: '79%', height: '100%' }">
      <div>
        <OaDetail :oaApproveItems="oaApproveItems" :oaVisi="oaVisi" :oaTitle="oaTitle" />
      </div>
    </van-popup>

    <div class="approve_info" v-if="lastFormItem.fieldType === 'interviewInfo'">
      <div v-for="(interItem, interIndex) in lastFormItem.value.appraises" :key="interIndex">
        <div>面试信息（第{{ interIndex + 1 }}轮）</div>
        <span>面试官：</span>
        <span>{{ interItem.appraiseStaffName }}</span>
        <br />
        <span>面试分数：</span>
        <span>{{ interItem.parentNumber }}</span>
        <br />
        <span>面试评价：</span>
        <span>{{ interItem.parentContent }}</span>
        <br />
      </div>
    </div>
    <div class="approve_info" v-if="lastFormItem.fieldType === 'interviewInfo'">
      <div>背调信息</div>
      <span>背调结论：</span>
      <span>通过</span>
      <br />
      <span>背调记录：</span>
      <span>{{ lastFormItem.value.backContent }}</span>
      <br />
    </div>
    <div class="annex_box" v-if="lastFormItem.fieldType === 'interviewInfo'">
      <div>背调附件</div>
      <div style="display: flex; justify-content: space-between; align-items: center" v-for="(i, index1) in lastFormItem.value.backFileList" :key="index1">
        <div class="annex_name">
          <img style="width: 22px; height: 20px; margin-right: 8px" src="@/assets/file@2x.png" />
          <div style="display: flex; flex-direction: column">
            <div style="width: 5rem; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
              {{ i ? i.name + i.suffix : '' }}
            </div>
            <div>{{ formatSize(i.size, 2) }}</div>
          </div>
        </div>
        <div class="annex_button" @click="preview(i.url)">预览</div>
        <div class="annex_button" @click="download(i)">下载</div>
      </div>
    </div>
    <div class="annex_box pdfItem" v-if="fileList.length > 0">
      <div style="font-size: 16px; line-height: 22px; margin-bottom: 10px; font-family: PingFangSC-Medium, PingFang SC; font-weight: 500; color: #333333">附件：</div>
      <div v-for="(item, index) in fileList" :key="index">
        <div style="display: flex; justify-content: space-between; align-items: center" v-for="(i, index1) in item.value" :key="index1">
          <div class="annex_name">
            <img style="width: 22px; height: 20px; margin-right: 8px" src="@/assets/file@2x.png" />
            <div style="display: flex; flex-direction: column">
              <div style="width: 5rem; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                {{ i ? i.name + i.suffix : '' }}
              </div>
              <div>{{ formatSize(i.size, 2) }}</div>
            </div>
          </div>
          <div class="annex_button" @click="preview(i.url)">预览</div>
          <div class="annex_button" @click="download(i)">下载</div>
        </div>
      </div>
    </div>
    <div class="annex_box" v-if="showApprovalFileList">
      <div style="font-size: 16px; line-height: 22px; margin-bottom: 10px; font-family: PingFangSC-Medium, PingFang SC; font-weight: 500; color: #333333">审批人附件：</div>
      <div v-for="(item, index) in links" :key="index">
        <div v-if="item.files.length > 0">{{ item.staffName }}</div>
        <div style="display: flex; justify-content: space-between; align-items: center" v-for="(i, index1) in item.files" :key="index1">
          <div class="annex_name">
            <img style="width: 22px; height: 20px; margin-right: 8px" src="@/assets/file@2x.png" />
            <div style="display: flex; flex-direction: column">
              <div style="width: 5rem; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                {{ i ? i.name + i.suffix : '' }}
              </div>
              <div>{{ formatSize(i.size, 2) }}</div>
            </div>
          </div>
          <div class="annex_button" @click="preview(i.url)">预览</div>
          <div class="annex_button" @click="download(i)">下载</div>
        </div>
      </div>
    </div>
    <div class="process_info pdfItem">
      <div style="font-size: 16px; line-height: 22px; margin-bottom: 10px; font-family: PingFangSC-Medium, PingFang SC; font-weight: 500; color: #333333">
        流程:
        <span style="float: right; font-size: 12px; color: #1584ff" v-if="oldInstanceId" @click="approveOld">查看原流程</span>
      </div>
      <div class="process_start">
        <div style="display: flex">
          <img v-if="initiator.avatar" :src="initiator.avatar" style="width: 40px; height: 40px; margin-right: 8px; border-radius: 0.21rem" />
          <img src="@/assets/default.png" class="member_img" v-else />
          <div style="display: flex; justify-content: space-between; width: 7rem">
            <div>
              <div style="color: #333333">发起申请</div>
              <div style="color: #333333; font-size: 12px">{{ initiator.staffName }}</div>
            </div>
            <div style="color: #999999">
              {{ initiator.createDate && initiator.createDate != '0' ? dayjs(Number(initiator.createDate)).format('YYYY-MM-DD HH:mm:ss') : '' }}
            </div>
          </div>
        </div>
        <div style="display: flex">
          <div class="process_arrow">
            <div style="height: 1rem"></div>
            <div></div>
          </div>
        </div>
      </div>
      <div
        :class="{
          process_start: true,
          process_end: index === links.length - 1
        }"
        v-for="(item, index) in links"
        :key="index"
      >
        <div style="display: flex">
          <img v-if="item.avatar" :src="item.avatar" style="width: 40px; height: 40px; margin-right: 8px; border-radius: 0.21rem" />
          <img src="@/assets/default.png" class="member_img" v-else />
          <div>
            <div :style="handleTimeStyle(item)">
              <div v-if="item.userType === 'approver'" style="color: #333333; font-size: 14px">
                <div v-if="kitValue == 99">接收人</div>
                <div v-else>审批人</div>
              </div>
              <div v-else style="color: #333333">办理人</div>
              <div :style="handleStyle(item)" class="approve_status">
                {{ renderStatus(item) }}
              </div>
              <div style="color: #999999">
                {{ item.actionTime && item.actionTime != '0' ? dayjs(Number(item.actionTime)).format('YYYY-MM-DD HH:mm:ss') : '' }}
              </div>
            </div>

            <div>
              <span style="color: #666666; font-size: 12px">
                {{ renderMember(item) }}
              </span>
              <span style="color: #1584ff; font-szie: 12px; opacity: 0.5" v-if="item.currentPosition">({{ item.currentPosition }})</span>
            </div>
          </div>
        </div>
        <div style="display: flex">
          <div class="process_arrow" v-if="index < links.length - 1">
            <div></div>
            <div></div>
          </div>
          <div class="process_arrow" style="min-height: 0" v-if="index === links.length - 1"></div>
          <div :class="{ 'approve-content': item.content }">{{ item.content }}</div>
        </div>
      </div>
    </div>
    <div class="cclist pdfItem">
      <div style="font-size: 16px; line-height: 22px; margin-bottom: 10px; font-family: PingFangSC-Medium, PingFang SC; font-weight: 500; color: #333333">抄送人:</div>
      <div style="display: flex; flex-wrap: wrap">
        <div class="selected-member" v-for="(item, index) in copyLink.members" :key="index">
          <img v-if="item.avatar" class="member-img" :src="item.avatar" />

          <img src="@/assets/default.png" class="member-img" v-else />
          <div style="color: #333333; font-size: 12px">
            {{ item.staffName }}
          </div>
        </div>
        <div class="selected-member" v-for="i in selectedList.copy" :key="i.staffId">
          <img v-if="i.avatar" class="member-img" :src="i.avatar" />
          <img src="@/assets/default.png" class="member-img" v-else />
          <div class="member-delete" @click="deleteMember(i, 'copy')">-</div>
          <div class="member-name">{{ i.staffName }}</div>
        </div>
        <div v-if="currentApproverFlag" style="cursor: pointer" @click="selectCopy">
          <img style="width: 1rem; height: 1rem" src="@/assets/join.svg" />
          <div style="font-size: 0.27rem; font-family: PingFangSC-Regular, PingFang SC; font-weight: 400; color: #666666">请添加</div>
        </div>
      </div>
    </div>
    <div class="botton_container" v-if="!showPersonTalk && showPrint" data-html2canvas-ignore>
      <!-- <van-button v-if="currentApproverFlag" type="primary">退回</van-button>
      <van-button v-if="allowRevokeFlag" @click="handleRevoke" type="primary">撤销</van-button>
      <van-button v-if="allowRevokeFlag" @click="handleRevise" type="primary">修改</van-button>-->
      <div class="more_btn" v-if="moreAction.length > 0" @click="moreActionShow = true">
        <img style="width: 0.59rem; height: 0.59rem" src="@/assets/more.png" />
        <div>更多</div>
      </div>
      <!-- <div class="more_btn" v-if="currentApproverFlag && !allowRevokeFlag">
        <img style="width:0.59rem;height:0.59rem" src="@/assets/return.png" />
        <div>退回</div>
      </div> -->
      <div class="agree_btn" v-if="showRevoke" @click="confirmRevoke" type="info">撤销</div>
      <div class="agree_btn" v-if="allowUrgeFlag" @click="confirmUrge" type="info">催办</div>
      <div class="refuse_btn" v-if="currentApproverFlag" @click="showDialog('2')">拒绝</div>
      <!-- <div :class="['agree_btn', this.finalStatus == 1 ? 'again_btn' : '']" @click="showDialog('8')" type="info">
        评论
      </div>-->
      <div class="agree_btn" v-if="currentApproverFlag" @click="showDialog('1')" type="info">同意</div>
      <div class="again_btn" v-if="againSubmitFlag" @click="handleRevise" type="primary">再次提交</div>

      <div class="again_btns" @click="print" v-if="finalStatus == 1" type="primary">打印</div>
    </div>
    <div class="botton_container" v-if="showPersonTalk" data-html2canvas-ignore>
      <div class="agree_btn" v-if="showRevoke" @click="confirmRevoke" type="info">撤销</div>
      <div class="agree_btn" v-if="currentApproverFlag" @click="handleDeliver" type="info">转交</div>
      <div class="agree_btn" v-if="currentApproverFlag" @click="showDialog('1')" type="info">评论</div>
      <div class="again_btn" v-if="againSubmitFlag" @click="handleRevise" type="primary">再次提交</div>
      <div class="more_btn" v-if="currentApproverFlag" @click="moreActionShow = true">
        <img style="width: 0.59rem; height: 0.59rem" src="@/assets/more.png" />
        <div>退回</div>
      </div>
    </div>
    <van-popup v-model="show" class="approve_box" :close-on-click-overlay="false">
      <p class="approve_idea">{{ boxTitle }}</p>
      <van-field v-model="message" class="approve_text" type="textarea" :placeholder="boxPlaceholder" />
      <!-- <span style="margin-left: 6.4rem">{{ textNumber }}/1000</span> -->
      <!-- <van-button type="info" @click="show = false;message = ''">取消</van-button>
      <van-button type="info" @click="handleApprove">确认</van-button> -->
      <div>
        <van-field name="uploader" label="附件">
          <template #input>
            <van-uploader :after-read="file => afterRead(file)" :before-delete="file => beforeDelete(file)" v-model="approvalFileList" accept="*" :preview-image="false">
              <template>
                <div>
                  <img style="width: 1rem; height: 1rem" src="@/assets/join.svg" />
                </div>
              </template>
            </van-uploader>
          </template>
        </van-field>
        <div v-for="(i, index) in approvalFileList" :key="index" style="display: flex; justify-content: space-between; align-items: center; padding: 10px 16px">
          <div class="annex-name" @click="preview(i.url)">
            <img style="width: 22px; height: 20px; margin-right: 8px" src="../assets/file@2x.png" />
            <div style="display: flex; flex-direction: column">
              <div style="width: 5rem; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                {{ renderFileName(i) }}
              </div>
              <div>{{ formatSize(i.size, 2) }}</div>
            </div>
          </div>
          <div class="annex-button" @click="deleteFile(i)">删除</div>
        </div>
      </div>
      <div class="approve_btns">
        <div
          @click="
            show = false;
            message = '';
            approvalAction = '';
          "
          style="height: 0.64rem; font-size: 0.43rem; color: #323233"
        >
          取消
        </div>
        <div style="border-left: 1px solid #ebedf0"></div>
        <div @click="handleApprove" style="height: 0.64rem; font-size: 0.43rem; color: #1584ff">确认</div>
      </div>
    </van-popup>
    <van-popup v-model="moreActionShow" round position="bottom">
      <van-picker show-toolbar :columns="moreAction" @cancel="moreActionShow = false" @confirm="onConfirm" />
    </van-popup>
    <van-popup class="uploading_popup" v-model="uploadLoading" round>
      <van-loading size="24px">文件上传中...</van-loading>
    </van-popup>
  </div>
</template>

<script>
import { getApplyInfo, handleArgee, getMakeCardTimes, upload, getReportApprovalList, getApprovalInstanceInfo } from '../axios/services';
import { Toast } from 'vant';
import 'vant/lib/index.css';
import { mapState, mapMutations } from 'vuex';
import dayjs from 'dayjs';
import { v4 as uuidv4 } from 'uuid';
import { formatSize } from '../utils';
import VeiBanBridge from '@/utils/bridge';
import OaDetail from './ApproveFormOaDetail.vue';
import htmlToPdf from '@/utils/htmlToPdf';

export default {
  components: {
    OaDetail
  },
  data() {
    return {
      isShowRemarkContent: false,
      remarkContent: '',
      finalStatusw: 0,
      formList: [], // 流程表单信息
      links: [], // 流程审批信息
      initiator: {}, // 发起人信息
      currentApprover: {},
      steps: 0,
      show: false,
      message: '', // 审批意见
      instanceId: '',
      approvalAction: '', // 审批动作
      currentApproverFlag: '',
      finalStatus: '',
      statusMsg: '',
      copyLink: {},
      allowRevokeFlag: null,
      againSubmitFlag: false,
      allowUrgeFlag: false,
      showRevoke: false,
      // showUrge: false,
      color: '',
      modelName: '',
      fileList: [],
      moreActionShow: false,
      moreAction: [],
      allowReturnToPrevFlag: '',
      boxTitle: '',
      boxPlaceholder: '',
      lastFormItem: {}, // 面试信息
      // textNumber: 0,
      isAndroid: false,
      isIos: false,
      showPersonTalk: false,
      makeCardTimes: '',
      approvalNo: '',
      approvalFileList: [],
      showApprovalFileList: false, // 是否展示审批人附件
      showPrint: true,
      uploadLoading: false, // 附件上传loading
      oaVisi: false,
      oaTitle: '',
      oaApproveItems: {
        // 关联oa审批单详情信息
        initiator: {},
        links: [],
        copyLink: {}
      },
      pdfFile: null,
      pdfLoading: false,
      oldInstanceId: ''
    };
  },
  watch: {
    links(val) {
      this.steps =
        val.findIndex(item => {
          return item.status === '00';
        }) != -1
          ? val.findIndex(item => {
              return item.status === '00';
            })
          : val.length;
    },
    finalStatus(val) {
      this.color = val === 1 ? 'green' : val === 2 ? '#fe5208' : '#ffba18';
    },
    approvalAction(val) {
      this.boxTitle = val === '8' ? '评论' : val === '1' || val === '2' ? '审批意见' : val === '3' ? '转交意见' : '退回意见';
      this.boxTitle = this.kitValue == 99 ? '评论' : this.boxTitle;
      this.boxPlaceholder = val === '8' ? '请输入评论' : val === '1' || val === '2' ? '请输入审批意见' : val === '3' ? '请输入转交意见' : '请输入退回意见';
      this.boxPlaceholder = this.kitValue == 99 ? '请输入意见' : this.boxPlaceholder;
      this.message = val === '1' ? '同意' : '';
      this.message = this.kitValue == 99 ? '' : this.message;
    },
    allowReturnToPrevFlag(val) {
      console.log('[ val ] >', val);
      if (!val && !this.allowRevokeFlag && !this.currentApproverFlag) {
        this.moreAction = [];
      }
      if (!val && this.allowRevokeFlag && !this.currentApproverFlag) {
        // this.moreAction = ['撤销'];
        this.showRevoke = true;
      }
      if (!val && this.allowRevokeFlag && this.currentApproverFlag) {
        this.moreAction = ['撤销', '退回', '转交'];
      }
      if (!val && !this.allowRevokeFlag && this.currentApproverFlag) {
        this.moreAction = ['退回', '转交'];
      }
      if (val && !this.allowRevokeFlag && !this.currentApproverFlag) {
        this.moreAction = [];
      }
      if (val && this.allowRevokeFlag && !this.currentApproverFlag) {
        // this.moreAction = ['撤销'];
        this.showRevoke = true;
      }
      if (val && !this.allowRevokeFlag && this.currentApproverFlag) {
        this.moreAction = ['退回', '退回上一个', '转交'];
      }
      if (val && this.allowRevokeFlag && this.currentApproverFlag) {
        this.moreAction = ['撤销', '退回', '退回上一个', '转交'];
      }
      if (this.showPersonTalk) {
        this.moreAction = val ? ['退回至发起人', '退回至上一审批节点'] : ['退回至发起人'];
      }
    }
    // message(val) {
    //   if (!this.showPersonTalk) {
    //     if (val.length > 1000) {
    //       this.message = this.message.slice(0, 1000);
    //     }
    //     this.textNumber = val.slice(0, 1000).length;
    //   }
    // },
  },

  methods: {
    ...mapMutations(['clearSelectedList']),
    print() {
      // this.finalStatus = 2;
      // if (this.finalStatus==2) {
      //     this.prints()
      //     console.log(this.finalStatus);
      //     //  this.prints()
      // }
      this.showPrint = false;
      console.log('执行打印');
      if (this.isAndroid) {
        window.androidPrint.print();
      } else {
        window.webkit.messageHandlers.iosPrint.postMessage('0');
      }
    },
    // 展示表格详情
    showRemarkContent(row) {
      console.log('[ row ] >', row);
      this.remarkContent = row.remark;
      this.isShowRemarkContent = true;
    },
    handleTimeStyle(item) {
      if (item.actionTime) {
        return {
          display: 'flex',
          'justify-content': 'space-between',
          width: '7rem'
        };
      } else {
        return {
          display: 'flex'
        };
      }
    },
    prints() {},
    deleteMember(item, number) {
      this.$store.commit('setCheckedList', {
        data: item,
        status: true,
        number
      });
      this.$forceUpdate();
    },

    dayjs,
    formatSize(size, length) {
      return ''; // 不需要展示文件大小

      return formatSize(size, length);
    },
    deleteFile(i) {
      this.approvalFileList = this.approvalFileList.filter(c => c.key !== i.key);
    },
    handleHeight(item, index) {
      const size = parseInt(document.documentElement.style.fontSize);
      if (index === this.links.length - 1) {
        let str = parseInt(Number(item.content?.length)) <= 18 ? 86 : parseInt(Number(item.content?.length) / 21 + 6) * 21;
        return isNaN(str) ? { height: `${60 / size}` } : { height: `${str / size}rem` };
      }
      let str = parseInt(Number(item.content?.length)) <= 18 ? 86 : parseInt(Number(item.content?.length) / 21 + 7) * 21;

      return isNaN(str) ? { height: `${80 / size}rem` } : { height: `${str / size}rem` };
    },
    handleArrowHeight(item) {
      const size = parseInt(document.documentElement.style.fontSize);
      let str = parseInt(Number(item.content?.length)) <= 18 ? 36 : parseInt(Number(item.content?.length) / 21 + 4) * 21;

      // if(item.content.length)
      return isNaN(str) ? { height: `${24 / size}rem` } : { height: `${str / size}rem` };
    },
    downloadFile(url) {
      window.location.href = url;
    },
    onClickLeft() {
      window.history.back();
    },
    confirmRevoke() {
      this.approvalAction = '3';
      this.handleRevoke();
    },
    handleDeliver() {
      // this.$router.push("/select-addressbook");
      // this.$store.commit("setType", true);
      this.$store.commit('setStatus', 'transfer');
      //设置审批id（instanceId）缓存
      localStorage.setItem('instanceId', this.initialData.instanceId);
      this.$router.push('/personnel-selection');
    },
    confirmUrge() {
      this.approvalAction = '9';
      this.handleRevoke();
    },
    onConfirm(e) {
      this.moreActionShow = false;
      if (e == '撤销') {
        this.approvalAction = '3';
        this.handleRevoke();
      }
      if (e == '修改') {
        this.handleRevise();
      }
      if (e == '退回' || e == '退回至发起人') {
        this.approvalAction = '4';
        this.show = true;
        // this.handleRevoke()
      }
      if (e == '退回上一个' || e == '退回至上一审批节点') {
        this.approvalAction = '5';
        this.show = true;
        // this.handleRevoke()
      }
      if (e == '转交') {
        // this.$router.push("/select-addressbook");
        // this.$store.commit("setType", true);
        this.$store.commit('setStatus', 'transfer');
        //设置审批id（instanceId）缓存
        localStorage.setItem('instanceId', this.initialData.instanceId);
        this.$router.push('/personnel-selection');
      }
    },
    handleStyle(item) {
      let str = '';
      switch (item.status) {
        case '0':
          str = 'color: #FFBA19;border: 1px solid #FFBA19';
          break;
        case '1':
          str = 'color: #00CA7B;border: 1px solid #00CA7B';
          break;
        case '' || '00':
          break;
        default:
          str = 'color: red;border: 1px solid red';
          break;
      }
      if (!item.actionTime) {
        str = str + ';margin-left: 0.7rem';
      }
      return str;
    },
    showFinalStatus() {
      switch (this.finalStatus) {
        case 0:
          if (this.kitValue == 99) {
            this.statusMsg = this.currentApprover?.staffName + '阅读中';
          } else {
            this.statusMsg = this.currentApprover?.staffName + '审核中';
          }
          break;
        case 1:
          if (this.kitValue == 99) {
            this.statusMsg = '已阅';
          } else {
            this.statusMsg = '通过';
          }
          break;
        case 2:
          this.statusMsg = '拒绝';
          break;
        case 3:
          this.statusMsg = '撤销';
          break;
        case 4:
          this.statusMsg = '被退回';
          break;
        default:
          break;
      }
    },
    renderStatus(item) {
      let status = '';
      switch (item.status) {
        case '0':
          if (this.kitValue == 99) {
            status = '未读';
          } else {
            status = '审核中';
          }
          break;
        case '1':
          if (this.kitValue == 99) {
            status = '已阅';
          } else {
            status = '通过';
          }
          break;
        case '2':
          status = '拒绝';
          break;
        case '3':
          status = '转交';
          break;
        case '4':
          status = '退回';
          break;
        case '5':
          status = '评论';
          break;
        case '7':
          status = '转交';
          break;
        default:
          break;
      }
      return status;
    },
    preview(param) {
      window.location.href = 'jsToOc://fujianJump?url=' + param;
    },
    download(item) {
      if (this.isAndroid) {
        window.attachmentDownload.downloadFile(item.url, item.name, item.suffix);
      } else {
        window.webkit.messageHandlers.attachmentDownload.postMessage({
          url: item.url,
          name: item.name,
          suffix: item.suffix
        });
      }
      // if(this.isIos) {

      // }
    },
    showDialog(e) {
      this.show = true;
      this.approvalAction = e;
    },
    selectCopy() {
      localStorage.setItem('instanceId', this.initialData.instanceId);
      this.$store.commit('setStatus', 'copy');
      this.$router.push('approval-personnel-selection');
      // window.JsCallNative.showNativeTitle(false)
    },
    // showAgreeDialog2() {
    //   this.show = true;
    //   this.approvalAction = '1'
    // },
    async handleApprove() {
      if (!this.message) {
        Toast.fail('未填写审批意见');
        return;
      }
      let config = {};
      // const user = JSON.parse(localStorage.getItem('user'));
      const user = (await VeiBanBridge.getUserInfo()) || {};
      config = {
        headers: {
          Token: user?.newToken
        }
      };

      const params = {
        linkId: this.currentApprover?.linkId || '',
        memberId: this.currentApprover?.memberId || '',
        instanceId: this.instanceId,
        approvalAction: this.approvalAction,
        content: this.message,
        companyId: this.initialData.companyId,
        staffId: this.currentApprover?.staffId || '',
        sort: this.currentApprover?.sort || 0,
        files: this.approvalFileList,
        copyMembers: this.selectedList?.copy || []
      };
      //提交中
      Toast.loading({
        message: '提交中...',
        duration: 0
      });
      // console.log('[ params ] >', params);
      // console.log('[ config ] >', config);
      // return;
      handleArgee(params, config).then(res => {
        if (res.data.code === 0) {
          this.show = false;
          if (this.approvalAction === '1') {
            this.message = '同意';
          } else {
            this.message = '';
          }
          this.approvalAction = '';
          //提交成功清除loading
          Toast.clear();
          //成功提示
          Toast.success('提交成功');
          document.documentElement.scrollTop = 0; //页面返回到顶部
          // this.handleBack(); //返回列表
          //查询列表是否有待审批
          this.getReportApprovalListFn();
        } else {
          Toast.fail(res.data.msg);
        }
      });
      /*
      .catch((error) => {
          Toast.clear();
          setTimeout(() => {
            Toast.loading({
              message: error,
              duration: 2000
           });
          }, 500);
      });
      */
    },
    handleCopyLink() {
      let str = '';
      for (let i = 0, len = this.copyLink.members?.length; i < len; i++) {
        str = i < len - 1 ? str + this.copyLink.members[i].staffName + '、' : str + this.copyLink.members[i].staffName;
      }
      return str;
    },
    flatten(arr) {
      let res = [];
      arr.map(item => {
        if (Array.isArray(item)) {
          res = res.concat(this.flatten(item));
        } else {
          res.push(item);
        }
      });
      return res;
    },
    handleRevoke() {
      const params = {
        linkId: this.currentApprover.linkId,
        memberId: this.currentApprover.memberId,
        instanceId: this.instanceId,
        approvalAction: this.approvalAction,
        content: this.message,
        companyId: this.initiator.companyId,
        staffId: this.currentApprover.staffId,
        sort: this.currentApprover.sort,
        copyMembers: this.selectedList?.copy || []
      };
      //提交中
      Toast.loading({
        message: '提交中...',
        duration: 0
      });
      handleArgee(params).then(res => {
        if (res.data.code === 0) {
          if (this.approvalAction === '1') {
            this.message = '同意';
          } else {
            this.message = '';
          }
          this.approvalAction = '';
          //提交成功清除loading
          Toast.clear();
          //成功提示
          Toast.success('提交成功');
          document.documentElement.scrollTop = 0; //页面返回到顶部
          //查询列表是否有待审批
          this.getReportApprovalListFn();
        } else {
          Toast.fail(res.data.msg);
        }
      });
      /*
      .catch((error) => {
          Toast.clear();
          setTimeout(() => {
            Toast.loading({
              message: error,
              duration: 2000
           });
          }, 500);
      });
     */
    },
    handleRevise() {
      this.$router.push('/apply-form');
    },
    renderItem(item) {
      let str = '';
      // if(item.fieldType === 'date-range') {
      //   str = item.value ? item.value[0] + '~' + item.value[1] : ''
      // }
      // if(item.fieldType === 'cascader' || item.fieldType === 'area') {
      //   item.value?.forEach(e => {
      //     str = str + '/' + e
      //   });
      //   str = str.substr(1)
      // }
      if (item.fieldType === 'upload') {
        return str;
      }
      if (item.fieldType === 'dept') {
        item.value?.forEach(e => {
          str = str + e.name + '/';
        });
        return str.slice(0, str.length - 1);
      }
      if (item.fieldType === 'switch') {
        return item.value ? '是' : '否';
      }
      if (item.fieldType === 'map') {
        str = item.value.address;
        return str;
      }
      if (item.fieldType === 'mapList') {
        let arr = item.value.map(item => {
          return item.name;
        });
        str = arr.toString();
        return str;
      }
      if (item.fieldType === 'position') {
        item.value?.forEach(e => {
          str = str + e.name + '/';
        });
        str = str.slice(0, str.length - 1);
        return str;
      }
      if (item.fieldType === 'department') {
        item.value?.forEach(e => {
          str = str + e.officeName + '/';
        });
        str = str.slice(0, str.length - 1);
        return str;
      }
      if (item.fieldType === 'company') {
        item.value?.forEach(e => {
          str = str + e.name + '/';
        });
        str = str.slice(0, str.length - 1);
        return str;
      }
      if (item.fieldName == '时长') {
        str = item.value + '小时';
        return str;
      }
      if (item.fieldName == '请假天数') {
        str = item.value + '天';
        return str;
      }
      return item.value;
    },
    renderTextArea(item) {
      return item.value;
    },
    renderTable(item) {
      const value = item.fieldValue;
      return JSON.parse(value);
    },
    renderTableTwo(item) {
      const value = item.fieldValue;
      try {
        // 第一次解析：处理外层 JSON
        const firstParse = JSON.parse(value);
        // 第二次解析：处理内层 JSON 字符串
        let parsedData;
        if (Array.isArray(firstParse)) {
          parsedData = firstParse.map(item => (typeof item === 'string' ? JSON.parse(item) : item));
        } else {
          parsedData = typeof firstParse === 'string' ? JSON.parse(firstParse) : firstParse;
        }

        return parsedData;
      } catch (error) {
        console.error('JSON 解析失败:', error);
        return []; // 默认返回空数组
      }
    },
    //表格合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index === 2 && column.property === 'remark') {
          sums[index] = '--';
        }
        if (data) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => Number.isNaN(value))) {
            sums[index] = `${values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!Number.isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)}`;
          } else {
            sums[index] = '--';
          }
        }
      });

      return sums;
    },
    handleBack() {
      // window.location.href = "jsToOc://back";
      if (this.fromApp) {
        window.location.href = 'jsToOc://back';
      } else {
        this.$store.commit('setFromApp', true);
        this.$router.push('/workReport');
      }
    },
    renderMemberName(name) {
      // 截取名字后两位
      let str = '';
      if (name) {
        if (name.length === 1) {
          str = name;
        }
        if (name.length > 1) {
          str = name.substr(-2, 2);
        }
      }
      return str;
    },
    renderMember(obj) {
      // return obj.position
      //   ? obj.staffName + `  (${obj.position})`
      //   : obj.staffName;
      return obj.staffName;
    },
    //打印取消
    printCancel() {
      this.showPrint = true;
      console.log('取消打印');
    },

    getPhoneType() {
      const u = navigator.userAgent;
      this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    },
    getMakeCardTimes() {
      const date = this.formList.find(i => i.fieldName == '补卡时间').value;
      const params = {
        date,
        staffId: this.initiator.staffId
      };
      getMakeCardTimes(params).then(res => {
        if (res.data.code === 0) {
          this.makeCardTimes = res.data.data;
        }
      });
    },
    renderFileName(item) {
      let str = item?.url?.slice(item?.url?.lastIndexOf('.'));
      let name = item?.fileName || item?.name;
      return name + str;
    },
    afterRead(file) {
      let content = file.file;
      let formData = new FormData();
      formData.append('file', content);
      const uuid = uuidv4();
      this.uploadLoading = true;
      upload(formData).then(res => {
        this.uploadLoading = false;
        this.approvalFileList = this.approvalFileList?.map(item => {
          if (Object.prototype.hasOwnProperty.call(item, 'file')) {
            return { ...res.data.data, key: uuid };
          } else {
            return item;
          }
        });
      });
    },
    beforeDelete(file) {
      this.approvalFileList = this.approvalFileList.filter(item => {
        if (Object.prototype.hasOwnProperty.call(file, 'file')) {
          return item.key !== file.file.key;
        } else {
          return item.key !== file.key;
        }
      });
    },
    //2023-08-15 fry => 获取审批详情单独抽出
    getApplyInfoFn(params) {
      //提交中
      Toast.loading({
        message: '加载中...',
        duration: 0
      });
      getApplyInfo(params).then(res => {
        if (res.data.code === 0) {
          this.kitValue = res.data.data.kitValue;
          if (this.kitValue === 10) {
            this.formList = res.data.data.fields.filter(item => item.fieldName !== '关联项目');
          } else {
            this.formList = res.data.data.fields;

            // 特殊处理 构造关联审批单数组
            this.formList.map(item => {
              if (item.fieldName == '关联审批单' || item.fieldName == '出差审批单') {
                item.fieldType = 'oaDetails';
                item.list = [];
                if (item.value) {
                  item.list = item.value.split(',');
                }
              }
              // 处理租赁时间[2023-10-01, 2024-11-30] 转换成 2023-10-01~2024-11-30
              if (item.fieldName == '租赁时间') {
                if (item.value) {
                  item.value = item.value[0] + '~' + item.value[1];
                }
              }
            });
          }
          this.lastFormItem = this.formList.slice(-1)[0];
          this.links = this.flatten(
            res.data.data.links.map(item =>
              item.members.map(i => ({
                ...i,
                userType: item.userType,
                files: i.files || []
              }))
            )
          );
          this.links.forEach(item => {
            if (item.files.length > 0) {
              this.showApprovalFileList = true;
            }
          });
          this.fileList = res.data.data.fields.filter(item => item.fieldType === 'upload');
          this.initiator = res.data.data.initiator;
          this.instanceId = res.data.data.instanceId;
          this.currentApprover = res.data.data.currentApprover;
          this.currentApproverFlag = res.data.data.currentApproverFlag;
          this.finalStatus = res.data.data.finalStatus;

          this.copyLink = res.data.data.copyLink;
          this.allowRevokeFlag = res.data.data.allowRevokeFlag;
          this.againSubmitFlag = res.data.data.againSubmitFlag;
          this.allowUrgeFlag = res.data.data.allowUrgeFlag;

          this.allowReturnToPrevFlag = res.data.data.allowReturnToPrevFlag;
          this.modelName = res.data.data.modelName;
          this.approvalNo = res.data.data.approvalNo;
          this.oldInstanceId = res.data.data.oldInstanceId || '';
          this.$store.commit('setApproveInfo', res.data.data);

          this.showFinalStatus();
          if (this.kitValue === 1) {
            this.getMakeCardTimes();
          } else {
            this.makeCardTimes = '';
          }
          //工作汇报套件
          if (this.kitValue == 99) {
            this.showPersonTalk = true;
          } else {
            this.showPersonTalk = false;
          }
          //提交成功清除loading
          Toast.clear();
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
    // 2023-08-15 - fry 获取审批列表
    getReportApprovalListFn() {
      // state,groupName,sceneType 方便ios/Android消息分类
      const paramsList = {
        companyId: this.initialData.companyId,
        currentPage: 1,
        currentPageSize: 1, //分页查一条的数据
        type: 1, //未审批的数据
        state: this.initialData.state,
        groupName: this.initialData.groupName,
        sceneType: this.initialData.sceneType
      };
      getReportApprovalList(paramsList).then(res => {
        if (res.data.code === 0) {
          let resData = res.data.data.records[0];
          if (res.data.data.records.length === 1) {
            this.$store.commit('setInitialData', {
              instanceId: resData.instanceId
            });
            localStorage.setItem('instanceId', resData.instanceId);
            const params = {
              instanceId: this.initialData.instanceId,
              companyId: this.initialData.companyId,
              draftFlag: 1
            };
            this.getApplyInfoFn(params);
          } else {
            //没有待审批返回列表
            this.handleBack();
          }
        } else {
          Toast.fail(res.data.msg);
        }
        //清除抄送人
        this.clearSelectedList({});
      });
    },
    // 获取oa详情
    getOaDetail(i) {
      let obj = {};
      obj.approvalNo = i;
      obj.draftFlag = 1;
      obj.companyId = this.initialData.companyId;
      getApprovalInstanceInfo(obj).then(res => {
        if (res.data.code === 0) {
          let data = res.data.data;
          this.oaApproveItems = data;
          this.oaVisi = true;
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },

    // 转发事件
    async wantWx() {
      if (this.pdfLoading) return;

      this.pdfFile = null;
      this.pdfLoading = true;

      await htmlToPdf.getPdf('abcd', '.record_container', this);

      this.afterPDFRead(this.pdfFile);
    },
    // pdf上传拿到url
    afterPDFRead(file) {
      if (!file) return;
      let filename = `${this.initiator.staffName}提出的${this.modelName}`;

      let content = htmlToPdf.base64toFile(file, filename);
      let formData = new FormData();
      formData.append('file', content);

      let attachment = this.fileList[0]?.value || []; // 附件

      upload(formData)
        .then(res => {
          this.pdfLoading = false;
          let pdfUrl = res.data?.data?.url;

          if (this.isAndroid) {
            let ja = JSON.stringify(attachment); // 安卓接收字符串
            window.androidPrint.print(filename, pdfUrl, ja);
          } else {
            window.webkit.messageHandlers.iosShareWx.postMessage({ filename: filename, pdfUrl: pdfUrl, attachment: attachment });
          }
        })
        .catch(err => {
          this.pdfLoading = false;
        });
    },
    getDate(format = 'yyyy-MM-dd', type) {
      let date = null;
      type = type || 'today';
      let now = +Date.now();
      let oneDay = 1000 * 60 * 60 * 24;
      let yesterday = now - oneDay;
      const typeDes = ['yesterday', 'today'];
      if (typeDes.includes(type)) {
        date = type === 'yesterday' ? new Date(yesterday) : new Date();
      } else {
        date = new Date(type);
      }
      if (date.toString() === 'Invalid Date') {
        return;
      }
      var o = {
        'M+': date.getMonth() + 1, //月份
        'd+': date.getDate(), //日
        'h+': date.getHours(), //小时
        'm+': date.getMinutes(), //分
        's+': date.getSeconds(), //秒
        'q+': Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
      };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
      }
      return format;
    },
    // CRM回款计划枚举
    // crm 0924
    paymentStatusGet(v) {
      const ind = v.executionStatus;
      const paymentDetailStatus = [
        { label: '执行中', value: 1 },
        { label: '已结案', value: 2 },
        { label: '逾期中', value: 3 },
        { label: '部分回款', value: 4 }
      ];

      let text = '';
      let o = paymentDetailStatus.find(itm => itm.value == ind);
      text = o.label || '';
      return text;
    },
    handleFieldName(itm, arr) {
      if (itm.fieldName === '报销单付款') {
        let amount = arr.find(itm => itm.fieldName == '合计总额（元）');
        let amountNum = amount?.value;
        amountNum = parseFloat(amountNum);

        let loan = arr.find(itm => itm.fieldName == '借款金额');
        let loanNum = loan?.value || 0;
        loanNum = parseFloat(loanNum);

        let text = '';

        if (loanNum < amountNum) {
          text = '应付';
        }
        if (loanNum > amountNum) {
          text = '应退';
        }
        if (loanNum == amountNum) {
          text = '应付/应退';
        }
        return text;
      }
      return itm.fieldName;
    },
    approveOld() {
      this.$router.push({
        path: '/approve-form-old-pg',
        query: {
          instanceId: this.oldInstanceId
        }
      });
    }
  },
  computed: {
    ...mapState(['initialData', 'selectedList', 'status', 'fromApp'])
  },
  created() {
    if (this.$route.query?.instanceId) {
      this.$store.commit('setInitialData', {
        instanceId: this.$route.query?.instanceId
      });
    }
    window.printCancel = this.printCancel;

    const params = {
      // instanceId: "24ea2002d0f6203b54298325cbfa00fd",
      // companyId: "cfe05dd2cedf4dd1ad9475d32838eaf9",
      companyId: this.initialData.companyId,
      instanceId: this.initialData.instanceId,
      draftFlag: 1
    };

    this.getApplyInfoFn(params);
    this.getPhoneType();
  }
};
</script>

<style scoped>
.record_container {
  width: 100vw;
  min-height: 100vh;
  padding-bottom: 10vh;
  padding-top: 1.71rem;
  position: relative;
  overflow: auto;
  background: #f9f9f9;
}
.info_tab {
  width: 100vw;
  height: 1.71rem;
  background: #ffffff;
  position: fixed;
  z-index: 99;
  padding-left: 0.43rem;
  line-height: 1.71rem;
  top: 0;
  left: 0;
}
.info_tab div {
  font-size: 0.48rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.info_container {
  width: 100vw;
  height: 1.89rem;
  background: #ffffff;
  padding: 0.37rem;
  border-top: 1px solid #f3f3f3;
  box-shadow: 0px 2px 4px 0px #f2f3f5;
}
.info_submit1 {
  font-size: 0.45rem;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  color: #333333;
  line-height: 0.64rem;
  margin-bottom: 0.13rem;
  display: flex;
  justify-content: space-between;
}
.info_submit2 {
  font-size: 0.37rem;
  font-family: SourceHanSansCN, SourceHanSansCN-Regular;
  font-weight: 400;
  color: #ffba18;
  line-height: 0.37rem;
}
.approve_info div {
  margin-bottom: 0.2rem;
}
.approve_info {
  width: calc(100vw - 0.75rem);
  margin: 0.53rem auto;
  padding: 0.43rem;
  padding-bottom: 0.2rem;
  background: #ffffff;
  box-shadow: 0rem 0.05rem 0.11rem 0rem #f2f3f5;
  border-radius: 0.21rem;
  font-size: 0.37rem;
}
.approve_company {
  width: calc(100vw - 0.75rem);
  margin: 0.3rem auto;
  padding: 0.2rem 0.43rem;
  background: #ffffff;
  box-shadow: 0rem 0.05rem 0.11rem 0rem #f2f3f5;
  border-radius: 0.21rem;
  font-size: 0.37rem;
}
.process_start {
  /* display: flex; */
  /* height: 80px; */
  /* justify-content: space-between; */
  padding: 4px 0;
  position: relative;
}

.process_arrow {
  width: 36px;
  display: inline;
  padding: 4px 16px;
  min-height: 1rem;
  /* position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: 45px;
  left: 16px; */
}
.approve-content {
  /* position: absolute;
  display: flex;
  flex-direction: column; */
  display: inline;
  width: 7.2rem;
  word-break: break-all;
  /* top: 45px;
  left: 47px;
  width: 73vw; */
  background: #efefef;
  border-radius: 6px;
  padding: 8px;
  margin-left: 0.2rem;
  font-size: 14px;
}
.process_arrow :first-child {
  width: 2px;
  height: 100%;
  margin-left: 2px;
  background: #00ca7b;
}
.process_arrow :last-child {
  width: 0;
  height: 0;
  border-right: 3px solid transparent;
  border-left: 3px solid transparent;
  border-top: 4px solid #00ca7b;
}
.process_info {
  width: calc(100vw - 0.75rem);
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 2px 4px 0px #f2f3f5;
  padding: 0.43rem;
  margin: 0 auto;
  margin-bottom: 0.43rem;
  padding-bottom: 0;
}
.cclist {
  width: calc(100vw - 0.75rem);
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 2px 4px 0px #f2f3f5;
  padding: 0.43rem;
  padding-right: 0;
  margin: 0 auto;
  margin-bottom: 0.43rem;
}
.cclist_list {
  margin-right: 0.2rem;
  display: flex;
  justify-content: space-between;
}
.member-img {
  width: 1rem;
  height: 1rem;
  border-radius: 4px;
}
.member-name {
  height: 0.37rem;
  font-size: 0.27rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 0.37rem;
  text-align: center;
  font-size: 12px;
  word-break: break-word;
}
.member-delete {
  color: white;
  background: red;
  border-radius: 0.4rem;
  width: 0.4rem;
  height: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -0.1rem;
  left: 0.7rem;
}
.botton_container {
  width: 100vw;
  height: 10vh;
  position: fixed;
  bottom: 0;
  left: 0;
  background: white;
  display: flex;
  align-items: center;
  box-shadow: 0px -2px 4px 0px #efefef;
}
.more_btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 1.17rem;
  margin-left: 0.59rem;
}
.refuse_btn {
  width: 2.2rem;
  height: 1.17rem;
  background: #ffffff;
  border-radius: 0.21rem;
  border: 0.03rem solid #666666;
  text-align: center;
  line-height: 1.17rem;
  margin-left: 0.7rem;
  font-size: 0.43rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3a3a3a;
}
.agree_btn {
  width: 2.2rem;
  height: 1.17rem;
  background: #1584ff;
  box-shadow: 0rem 0.05rem 0.21rem 0rem #80bcff;
  border-radius: 0.21rem;
  text-align: center;
  line-height: 1.17rem;
  margin-left: 0.59rem;
  font-size: 0.43rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.again_btn {
  width: 8.29rem !important;
  height: 1.17rem;
  margin: 0 auto;
  background: #1584ff;
  box-shadow: 0rem 0.05rem 0.21rem 0rem #80bcff;
  border-radius: 0.21rem;
  font-size: 0.43rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 1.17rem;
  text-align: center;
}
.again_btns {
  width: 2.29rem !important;
  height: 1.17rem;
  margin: 0 auto;
  background: #1584ff;
  box-shadow: 0rem 0.05rem 0.21rem 0rem #80bcff;
  border-radius: 0.21rem;
  font-size: 0.43rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 1.17rem;
  text-align: center;
}
.annex_box {
  width: calc(100vw - 0.75rem);
  margin: 0 auto;
  margin-bottom: 0.43rem;
  padding: 0.43rem;
  background: #ffffff;
  border-radius: 0.21rem;
  box-shadow: 0rem 0rem 0rem 0rem #f2f3f5;
}
.annex_button {
  width: 1.41rem;
  background: #ffffff;
  border-radius: 0.11rem;
  border: 0.03rem solid #1584ff;
  font-size: 0.32rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1584ff;
  text-align: center;
  line-height: 0.7rem;
  height: 0.7rem;
  margin-right: 0.1rem;
}
.annex_name {
  display: flex;
  align-items: center;
}
.approve_idea {
  width: 8.29rem;
  height: 0.96rem;
  font-size: 0.43rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #323233;
  line-height: 0.96rem;
  text-align: center;
  margin: 0;
}
.approve_text {
  width: 6.5rem;
  height: 3.2rem;
  background: #ffffff;
  border-radius: 0.05rem;
  border: 0.01rem solid #dcdde0;
  margin: 0 auto;
}
.approve_btns {
  width: 8.29rem;
  height: 1.28rem;
  background: #ffffff;
  border-radius: 0rem 0rem 0.11rem 0.11rem;
  display: flex;
  line-height: 1.28rem;
  justify-content: space-around;
  margin-top: 0.5rem;
  border: 1px solid #ebedf0;
}
/* .approve_idea:before {
    content: '*';
    color: red;
  } */
.approve_box {
  width: 8.29rem;
  background: #ffffff;
  border-radius: 0.11rem;
}
.approve_status {
  width: 1.3rem;
  /* height: 0.5rem; */
  border-radius: 4px;
  font-size: 10px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: center;
  line-height: 0.5rem;
  margin-left: 10px;
}
.selected_member {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1.5rem;
  height: 1.5rem;
  position: relative;
}
.selected-member {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1rem;
  position: relative;
  margin-right: 0.2rem;
  margin-bottom: 0.3rem;
}
.member_img {
  width: 40px;
  height: 40px;
  margin-right: 8px;
  border-radius: 0.21rem;
}
.staffNameBox {
  width: 40px;
  height: 40px;
  background: #1584ff;
  border-radius: 0.21rem;
  font-size: 0.32rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
}
.info_field {
  font-size: 0.37rem;
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: bold;
  color: #333333;
  margin-right: 0.15rem;
}
.info_text {
  word-wrap: break-word;
  white-space: pre-wrap;
  font-size: 0.37rem;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #555555;
  line-height: 0.67rem;
}
.info_witpark {
  margin: 0.28rem 0;
  /* div {
    padding-left: 0.28rem;
  }
  .line {
    padding: 0;
    border-bottom: 1px solid #ccc;
  } */
}
.info_witpark div {
  padding-left: 0.28rem;
}

.info_witpark .line {
  padding: 0;
  border-bottom: 1px solid #ccc;
}

.approve_list {
  background: #f5f6f7;
  border-radius: 4px;
  padding: 0.2rem;
}
.van-cell /deep/ .van-field__body {
  height: 100%;
}
.van-cell /deep/ .van-field__control {
  height: 100%;
}
.van-cell /deep/ .van-field__label {
  width: auto !important;
  color: #333;
  font-size: 16px;
  font-weight: 500;
}
.van-cell /deep/ .van-field__control--custom {
  display: flex;
  justify-content: flex-end;
}
.annex-name {
  display: flex;
  align-items: center;
}
.uploading_popup {
  height: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.approve_click {
  color: #409eff;
}
.zf {
  padding-left: 2px;
  vertical-align: middle;
}
</style>
